export const ERROR_PAGINATION_NEGATIVE_ARGUMENT = 'Один или оба элемента отрицательные';
export const ERROR_PAGINATION_BOTH_ARGUMENTS_IS_EQUAL =
    'Оба аргумента равны и больше единицы. Невозможно построить пагинацию';

export const fillArrayFromAtoB = (a: number, b: number) => {
    if (a < 1 || b < 1) {
        throw new Error(ERROR_PAGINATION_NEGATIVE_ARGUMENT);
    }

    if (a === b && a !== 1) {
        throw new Error(ERROR_PAGINATION_BOTH_ARGUMENTS_IS_EQUAL);
    }

    const min = Math.min(a, b);
    const max = Math.max(a, b);

    const arr: number[] = [];

    for (let i = min; i <= max; i++) {
        arr.push(i);
    }

    return arr;
};

interface IGetPagination {
    activePadding: number;
    currentPageNumber: number;
    pages: number;
    sidePadding: number;
}

export const getPagination = ({
    activePadding,
    currentPageNumber,
    pages,
    sidePadding,
}: IGetPagination) => {
    if (pages <= sidePadding) {
        return fillArrayFromAtoB(1, pages);
    }

    if (currentPageNumber < sidePadding) {
        return fillArrayFromAtoB(1, sidePadding).concat(0).concat(pages);
    }

    if (currentPageNumber > pages - sidePadding + 1) {
        return [1].concat(0).concat(...fillArrayFromAtoB(pages - sidePadding + 1, pages));
    }

    return [1]
        .concat(0)
        .concat(
            ...fillArrayFromAtoB(
                currentPageNumber - activePadding,
                currentPageNumber + activePadding
            )
        )
        .concat(0)
        .concat(pages);
};

interface IGetPagesCountArgs {
    elementsCount?: number;
    limit: number;
    pagesCount?: number;
}

// Определяет количество страниц на основе количества переданных элементов или страниц
export const getPagesCount = ({ elementsCount, limit, pagesCount }: IGetPagesCountArgs) => {
    if (elementsCount) {
        const hasRemainder = Boolean(elementsCount % limit);
        const result = Math.floor(elementsCount / limit);

        return hasRemainder ? result + 1 : result;
    }

    return pagesCount ?? 1;
};
